"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9365],{

/***/ 59365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var FACTORIAL_OPEN_POSITIONS_URL = "/api/open-jobs";
var ATTRIBUTES_TO_REMOVE = [
    "data-action",
    "data-controller",
    "role",
    "data-job-postings-url"
];
var FactorialOpenPositions = function(param) {
    var _title = param.title, title = _title === void 0 ? "Factorial Open Positions" : _title, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "600px" : _height, _src = param.src, src = _src === void 0 ? FACTORIAL_OPEN_POSITIONS_URL : _src;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(height), iframeHeight = ref1[0], setIframeHeight = ref1[1];
    var handleOnload = function() {
        var ref1, ref2, ref3, ref4;
        if (!(ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentWindow) === null || ref2 === void 0 ? void 0 : ref2.document)) return;
        var innerDocument = ref.current.contentWindow.document;
        var jobList = innerDocument.querySelectorAll("li");
        jobList === null || jobList === void 0 ? void 0 : jobList.forEach(function(job) {
            var // and add target="_parent" to the links to open them in the parent window
            ref;
            // We remove these attributes to avoid navigation inside the iframe
            ATTRIBUTES_TO_REMOVE.forEach(function(attribute) {
                return job.removeAttribute(attribute);
            });
            (ref = job.querySelector("a")) === null || ref === void 0 ? void 0 : ref.setAttribute("target", "_parent");
        });
        (ref3 = innerDocument.body) === null || ref3 === void 0 ? void 0 : ref3.setAttribute("style", "overflow: hidden;");
        // Calculate the height of the iframe based on the height of the content
        var innerHeight = (ref4 = innerDocument.body) === null || ref4 === void 0 ? void 0 : ref4.scrollHeight;
        setIframeHeight("".concat(innerHeight, "px"));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
        ref: ref,
        title: title,
        width: width,
        height: iframeHeight,
        src: src,
        onLoad: handleOnload
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FactorialOpenPositions);


/***/ })

}]);